export default __webpack_public_path__ + "3ec13a24af3fdda1110771d3541915a2.ttf";